import axios from 'axios';

import type {
  IAssistantRagVectorStorage,
  ICreateAssistantRagVectorStorage,
  IUpdateAssistantRagVectorStorage,
} from '../interfaces/assistantRagStorage';

let baseUrl = '';
let getToken: (() => string | null | undefined) | null = null;

export default class AssistantRagStorageService {
  static configure(
    url: string,
    options?: { getToken?: () => string | null | undefined },
  ): void {
    baseUrl = url;

    if (options?.getToken) {
      getToken = options.getToken;
    }
  }

  private static authConfig(extra: any = {}): any {
    const token = getToken?.();

    if (!token) {
      return extra;
    }

    return {
      ...extra,
      headers: { ...(extra.headers || {}), Authorization: `Bearer ${token}` },
    };
  }

  static async getAssistantRagStorageItems(
    config: any = {},
  ): Promise<IAssistantRagVectorStorage[]> {
    const { data } = await axios.get(
      `${baseUrl}api/v2/assistant/rag/storage`,
      this.authConfig(config),
    );

    return data;
  }

  static async getAssistantRagStorageS3TextData(
    config: any = {},
    s3Key: string,
  ): Promise<string> {
    const { data } = await axios.get(
      `${baseUrl}api/v2/assistant/rag/storage/text-data/${s3Key}`,
      this.authConfig(config),
    );

    return data?.textData;
  }

  static async getAssistantRagStorageTags(config: any = {}): Promise<string[]> {
    const { data } = await axios.get(
      `${baseUrl}api/v2/assistant/rag/storage/tags`,
      this.authConfig(config),
    );

    return data;
  }

  static async updateAssistantRagStorageItem(
    ragVectorLinkId: string,
    data: IUpdateAssistantRagVectorStorage,
    config: any = {},
  ): Promise<{ data: IAssistantRagVectorStorage | null }> {
    return axios.patch(
      `${baseUrl}api/v2/assistant/rag/storage/${ragVectorLinkId}`,
      data,
      this.authConfig(config),
    );
  }

  static async createAssistantRagStorageItem(
    data: ICreateAssistantRagVectorStorage,
    config: any = {},
  ): Promise<{ data: IAssistantRagVectorStorage | null }> {
    return axios.post(
      `${baseUrl}api/v2/assistant/rag/storage`,
      data,
      this.authConfig(config),
    );
  }

  static async deleteAssistantRagStorageItem(ragVectorLinkId: string) {
    return axios.delete(
      `${baseUrl}api/v2/assistant/rag/storage/${ragVectorLinkId}`,
      this.authConfig(),
    );
  }
}
